/**
 * Base58 encoding/decoding (Bitcoin-style alphabet)
 */

const ALPHABET = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';
const ALPHABET_MAP = new Map<string, number>();

for (let i = 0; i < ALPHABET.length; i++) {
  ALPHABET_MAP.set(ALPHABET[i], i);
}

export const base58 = {
  encode(bytes: Uint8Array): string {
    if (bytes.length === 0) return '';

    // Count leading zeros
    let zeros = 0;
    while (zeros < bytes.length && bytes[zeros] === 0) {
      zeros++;
    }

    // Convert bytes to base58
    const size = Math.ceil(bytes.length * 138 / 100) + 1;
    const b58 = new Uint8Array(size);

    let length = 0;
    for (let i = zeros; i < bytes.length; i++) {
      let carry = bytes[i];
      let j = 0;

      for (let k = size - 1; (carry !== 0 || j < length) && k >= 0; k--, j++) {
        carry += 256 * b58[k];
        b58[k] = carry % 58;
        carry = Math.floor(carry / 58);
      }

      length = j;
    }

    // Skip leading zeros in base58 result
    let i = size - length;
    while (i < size && b58[i] === 0) {
      i++;
    }

    // Build result string
    let result = ALPHABET[0].repeat(zeros);
    for (; i < size; i++) {
      result += ALPHABET[b58[i]];
    }

    return result;
  },

  decode(str: string): Uint8Array {
    if (str.length === 0) return new Uint8Array(0);

    // Count leading '1's (zeros)
    let zeros = 0;
    while (zeros < str.length && str[zeros] === '1') {
      zeros++;
    }

    // Convert base58 to bytes
    const size = Math.ceil(str.length * 733 / 1000) + 1;
    const bytes = new Uint8Array(size);

    let length = 0;
    for (let i = zeros; i < str.length; i++) {
      const value = ALPHABET_MAP.get(str[i]);
      if (value === undefined) {
        throw new Error(`Invalid base58 character: ${str[i]}`);
      }

      let carry = value;
      let j = 0;

      for (let k = size - 1; (carry !== 0 || j < length) && k >= 0; k--, j++) {
        carry += 58 * bytes[k];
        bytes[k] = carry % 256;
        carry = Math.floor(carry / 256);
      }

      length = j;
    }

    // Skip leading zeros in result
    let i = size - length;
    while (i < size && bytes[i] === 0) {
      i++;
    }

    // Build result with leading zeros
    const result = new Uint8Array(zeros + (size - i));
    for (let j = zeros; i < size; i++, j++) {
      result[j] = bytes[i];
    }

    return result;
  }
};
